import React from "react";
import "./work.css";
import Projects from "./Projects";

const Work = () => {
  return (
    <section className="work section">
      <h2 className="section__title">Projects</h2>
      <span className="section__subtitle">School and Personal Projects</span>
      <Projects />
    </section>
  );
};

export default Work;
